import { get, post, handleError } from '@/lib/http-adapter';
import { User } from '@/state/user';
import { SubscriptionCode } from '@/state/subscription-codes';

export const getSubscriptionCodes = async (filters?: {
  user_id?: SubscriptionCode['user_id'];
  email?: User['email'];
}) => {
  try {
    const response = await get<{
      subscription_codes: SubscriptionCode[];
    }>('public/subscription-codes', { params: filters });

    return response?.subscription_codes;
  } catch (error) {
    handleError(error);
  }
};

export const createPaymentMethodUpdateSession = async (
  subscriptionCodeId: string,
  returnUrl: string
): Promise<{ url: string } | undefined> => {
  try {
    return await post<{ url: string }>(
      '/public/stripe/payment-method-update-session',
      { subscriptionCodeId, returnUrl }
    );
  } catch (error) {
    handleError(error);
  }
};

export interface RetryPaymentResult {
  success: boolean;
  invoice_status?: string;
  failure: {
    code: string | null;
    decline_code: string | null;
    reason: string | null;
    type: string | null;
    last_event_type: string;
  } | null;
}

export const retrySubscriptionPayment = async (
  subscriptionCodeId: string
): Promise<RetryPaymentResult | undefined> => {
  try {
    return await post<RetryPaymentResult>(
      `/public/subscription-codes/${subscriptionCodeId}/retry-payment`,
      {}
    );
  } catch (error) {
    handleError(error);
  }
};

